import { gql } from 'graphql-request'

export const UPDATE_POPUP_BANNER = gql`
  mutation UpdatePopupBanner($updatePopupBannerInput: UpdatePopupBannerInput!) {
    updatePopupBanner(updatePopupBannerInput: $updatePopupBannerInput) {
      id
    }
  }
`
